import { getWMSLayer } from './getWMSLayer'
import { getTMSLayer } from './getTMSLayer'
import { getUTSLayer, getUTSSLayer } from './getUTSLayer'
import { getSingleLayerInfo } from './getSingleLayer'
import { getTDTLayerTMS } from './defaultLayer/getTiandituLayer'
import { addGeojsonLayer, removeGeojsonLayer } from './getGeojsonLayer'
import { addWindLayer, removeWindLayer } from './getWindLayer'

// 特殊图层 自己负责删除修改
import { addTerrainLayer, removeTerrainLayer } from './getTerrainLayer'
import { addSatOrbLayer, removeSatOrbLayer } from './entities/getOrbitLayer'
import { addSatelliteLayer, setSatelliteLayer, removeSatelliteLayer } from './entities/addSatelliteLayer'

import { setLayerShow } from './layerVisibleControl'
import {
  checkLayerExist,
  addLayerExist,
  getLayerExist,
  removerLayerExist
} from './layerStatusControl'

import { getZIndexByType } from './layerZIndex'
import { setLayerZIndex } from './layerZIndexControl'
import { setLayerAlpha } from './layerAlphaControl'

import { addLonLatGird, removeLonLatGird } from './lonLatLayer/addLonLatLayer'

import { addSatInfoCZMLLayer, removeSatInfoCZMLLayer } from './cmzl/addSatInfoLayer'

import { addStationDataList, removeStationDataList } from './entities/addStationInfo'

// 单图 有高度数据
import { addSingeHeightLayer, removeSingeHeightLayer } from './entities/addSingleHeightLayer'

// 3dTile 图层
import { add3DTilesLayer, remove3DTilesLayer } from './primitives/add3DTileLayer'

// 航线数据
import { addSailLineGeoJsonLayer, removeSailLineGeoJsonLayer } from './geojson/addSailLineGeojsonLayer'

// geojson 格式的 轨道数据 - czml 添加
import { addSatOrbGeoLayer, removeSatOrbGeoLayer } from './cmzl/addOrbitGeojsonLayer'


function addLayer (params, self) {
  const layerType = params.mapType || 'WMS'
  self = self || this
  if (checkLayerExist(params)) {
    console.log('已经添加过此ID的图层：' + params.id)
    return false
  }
  // step1
  params.zIndex = getZIndexByType(params)
  let returnMarket = null
  const viewer = self.viewer
  switch (layerType) {
    case 'WMS': {
      const WMSProvider = getWMSLayer(params)
      returnMarket = addImageryProvider(params, WMSProvider, viewer, self)
      break
    }
    case 'TMS': {
      const TMSProvider = getTMSLayer(params)
      returnMarket = addImageryProvider(params, TMSProvider, viewer, self)
      break
    }
    case 'UTS': {
      const UTSProvider = getUTSLayer(params)
      returnMarket = addImageryProvider(params, UTSProvider, viewer, self)
      break
    }
    case 'UTTS':
    case 'UTSS': {
      const UTSSProvider = getUTSSLayer(params)
      returnMarket = addImageryProvider(params, UTSSProvider, viewer, self)
      break
    }
    case 'UTTSXYZ': {
      const UTTSXYZProvider = getUTSSLayer(params, 'XYZ')
      returnMarket = addImageryProvider(params, UTTSXYZProvider, viewer, self)
      break
    }
    case 'IMAGE':
    case 'singleImage': {
      const singleProvider = getSingleLayerInfo(params)
      returnMarket = addImageryProvider(params, singleProvider, viewer, self)
      break
    }
    case 'geojson': {
      addSatOrbGeoLayer(params, viewer)
      break
    }
    case 'GEOJSON': {
      addGeojsonLayer(params, viewer)
      break
    }
    case 'Terrain': {
      addTerrainLayer(params, viewer)
      break
    }
    case 'SatOrb': {
      addSatOrbLayer(params, viewer)
      break
    }
    case 'Sate': {
      addSatelliteLayer(params, viewer)
      break
    }
    case 'SatOrbCZML': {
      addSatInfoCZMLLayer(params, viewer)
      break
    }
    case 'StaDataList': {
      addStationDataList(params, viewer)
      break
    }
    case 'TDT':
    case 'tdt': {
      const singleTDTProvider = getTDTLayerTMS(params)
      returnMarket = addImageryProvider(params, singleTDTProvider, viewer, self)
      break
    }
    case 'heightImage': {
      addSingeHeightLayer(params, viewer)
      break
    }
    case '3DTiles': {
      add3DTilesLayer(params, viewer)
      break
    }
    case 'Wind': {
      addWindLayer(params, viewer)
      break
    }
    case 'sail': {
      addSailLineGeoJsonLayer(params, viewer)
      break
    }
    default: {
      break
    }
  }

  return returnMarket
}

function addImageryProvider (params, imageProvider, viewer, self) {
  if (!self) {
    self = this
  }
  const imageMarket = viewer.imageryLayers.addImageryProvider(imageProvider)
  const addInfo = {
    info: params,
    layer: imageProvider,
    market: imageMarket
  }
  addLayerExist(addInfo)
  // 设置当前参数
  setLayerParams(params, params, self)
  return imageMarket
}

// 基于参数设置
function setLayerParams (layerinfo, params, _self) {
  let self = _self
  if (!self) {
    self = this
  }
  // 设置 zIndex
  if (params.zIndex) {
    setLayerZIndex(layerinfo, params.zIndex, self)
  }
  // 设置可视化情况
  if (params.visible || params.visible === false) {
    setLayerShow(layerinfo, params.visible, self)
  }
  // 设置透明度
  if (params.opacity) {
    setLayerAlpha(layerinfo, params.opacity, self)
  }
}

// 卫星移动
function setSatelliteParams (layerinfo, self) {
  self = self || this
  const viewer = self.viewer
  if (layerinfo.position) {
    setSatelliteLayer(layerinfo, viewer)
  }
}

function removeLayer (removeparam, self) {
  self = self || this
  const viewer = self.viewer
  let mapType = removeparam.mapType
  if (mapType === 'GEOJSON') {
    removeGeojsonLayer(removeparam, viewer)
    return true
  }
  if (mapType === 'StaDataList') {
    removeStationDataList(viewer)
    return true
  }
  // 获取当前图层存在状态
  const addedLayer = getLayerExist(removeparam)
  if (!addedLayer) {
    return false
  }
  // 基于存储内容 矫正 mapType 内容
  const layerInfo = addedLayer.info
  if (layerInfo) {
    mapType = removeparam.mapType || layerInfo.mapType
  }
  switch (mapType) {
    case 'WMS':
    case 'TMS':
    case 'UTS':
    case 'UTTS':
    case 'UTSS':
    case 'IMAGE':
    case 'TDT':
    case 'tdt': {
      viewer.imageryLayers.remove(addedLayer.market)
      // 移除 imageryLayers
      removerLayerExist(removeparam)
      break
    }
    case 'geojson': {
      // geojson 的轨道数据移除
      removeSatOrbGeoLayer(removeparam, viewer)
      removerLayerExist(removeparam)
      break
    }
    case 'SatOrb': {
      // 轨道数据
      removeSatOrbLayer(removeparam, viewer)
      removerLayerExist(removeparam)
      break
    }
    case 'SatOrbCZML': {
      // 轨道数据CZML
      removeSatInfoCZMLLayer(removeparam, viewer)
      removerLayerExist(removeparam)
      break
    }
    case 'Sate': {
      // 卫星
      removeSatelliteLayer(removeparam, viewer)
      break
    }
    case 'Terrain': {
      removeTerrainLayer()
      break
    }
    case 'heightImage': {
      removeSingeHeightLayer(removeparam, viewer)
      break
    }
    case '3DTiles': {
      remove3DTilesLayer(removeparam, viewer)
      break
    }
    case 'sail': {
      removeSailLineGeoJsonLayer(removeparam, viewer)
      break
    }
    case 'Wind': {
      removeWindLayer(removeparam, viewer)
      break
    }
    default: {
      // TODO 其他模式下的移除
      break
    }
  }
  return true
}

export { addLayer, removeLayer, setLayerParams, addLonLatGird, removeLonLatGird, setSatelliteParams }
